import axios from "axios";

// When testing in browser on localhost, automatically route to local backend server http://localhost:8000
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.startsWith("192.168.") ||
    window.location.hostname.startsWith("172."));

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (isLocalhost ? "http://localhost:8000" : "http://localhost:8000");

const cleanBase = BACKEND_URL.replace(/\/+$/, "");
export const API = cleanBase.endsWith("/api") ? cleanBase : `${cleanBase}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cvolve_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
